import { useState } from 'react';
import { downloadCsv, useTrialBalance } from '../hooks/useReports';
import { accountCategoryLabels } from '../hooks/useAccounts';
import PrintButton from '../components/PrintButton';

export default function TrialBalancePage() {
  const today = new Date();
  const yearStart = `${today.getFullYear()}-01-01`;
  const yearEnd = `${today.getFullYear()}-12-31`;

  const [dateFrom, setDateFrom] = useState(yearStart);
  const [dateTo, setDateTo] = useState(yearEnd);
  const [applied, setApplied] = useState({ dateFrom: yearStart, dateTo: yearEnd });
  const { data, isLoading, error } = useTrialBalance(applied);

  return (
    <div>
      <div className="page-header">
        <h2>合計残高試算表</h2>
      </div>
      {error && <div className="error-banner">{(error as Error).message}</div>}

      <div className="card">
        <div className="toolbar">
          <label>
            日付From{' '}
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
          </label>
          <label>
            日付To{' '}
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          </label>
          <button className="primary" onClick={() => setApplied({ dateFrom, dateTo })}>
            表示
          </button>
          <button onClick={() => downloadCsv('/api/reports/trial-balance', applied)}>CSV出力</button>
          <PrintButton />
        </div>
      </div>

      {isLoading && <div>読み込み中...</div>}

      {data && (
        <>
          <table>
            <thead>
              <tr>
                <th style={{ width: 90 }}>コード</th>
                <th>勘定科目</th>
                <th style={{ width: 90 }}>区分</th>
                <th className="numeric" style={{ width: 130 }}>借方合計</th>
                <th className="numeric" style={{ width: 130 }}>貸方合計</th>
                <th className="numeric" style={{ width: 130 }}>残高</th>
              </tr>
            </thead>
            <tbody>
              {data.summaries.map((r) => (
                <tr key={r.accountId}>
                  <td>{r.code}</td>
                  <td>{r.name}</td>
                  <td>{accountCategoryLabels[r.category]}</td>
                  <td className="numeric">{r.debitTotal.toLocaleString()}</td>
                  <td className="numeric">{r.creditTotal.toLocaleString()}</td>
                  <td className="numeric">{r.balance.toLocaleString()}</td>
                </tr>
              ))}
              {data.summaries.length === 0 && (
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center', padding: 24 }} className="text-muted">
                    取引がありません
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={3} style={{ textAlign: 'right' }}>
                  総合計
                </th>
                <th className="numeric">{data.grandTotal.debit.toLocaleString()}</th>
                <th className="numeric">{data.grandTotal.credit.toLocaleString()}</th>
                <th
                  className="numeric"
                  style={{
                    color: data.grandTotal.balanced ? 'var(--color-success)' : 'var(--color-danger)',
                  }}
                >
                  {data.grandTotal.balanced ? '一致' : '不一致'}
                </th>
              </tr>
            </tfoot>
          </table>
        </>
      )}
    </div>
  );
}
